import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { SchoolSearchResultsItem } from '../../scp/schools/models';

@Component({
  selector: 'opus-reports-school-searchresults-table-row',
  templateUrl: './reports-school-searchresults-row.component.html',
})
export class ReportsSchoolSearchResultsRowComponent implements OnInit, OnDestroy, OnChanges {
  @Input() schoolItm: SchoolSearchResultsItem;
  @Input() item: FormGroup;

  //alive = true;

  ngOnInit() {

  }

  ngOnDestroy() {
    /*  this.alive = false;*/
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  static BuildItem(school: SchoolSearchResultsItem): FormGroup {
    return new FormGroup({
      isSelected: new FormControl(),
      id: new FormControl(school.id),
      schoolName: new FormControl(school.longName),
      levelName: new FormControl(school.levelName),
      districtId: new FormControl(school.districtId),
      districtName: new FormControl(school.districtName),
      city: new FormControl(school.city),
      state: new FormControl(school.state),
    });
  }
}
